export const GET_USER_PROFILE_CARD_REQUEST = "GET_USER_PROFILE_CARD_REQUEST";
export const GET_USER_PROFILE_CARD_SUCCESS = "GET_USER_PROFILE_CARD_SUCCESS";
export const GET_USER_PROFILE_CARD_FAIL = "GET_USER_PROFILE_CARD_FAIL";

export const GET_AUTH_PROFILE_CARD_REQUEST = "GET_AUTH_PROFILE_CARD_REQUEST";
export const GET_AUTH_PROFILE_CARD_SUCCESS = "GET_AUTH_PROFILE_CARD_SUCCESS";
export const GET_AUTH_PROFILE_CARD_FAIL = "GET_AUTH_PROFILE_CARD_FAIL";
